var _path, _path2, _path3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopifyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-label": "Shopify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20c0-8 4-13 9.5-13S40 12 40 19",
    fill: "none",
    stroke: "#95bf47",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20l35-4 6 43H7z",
    fill: "#95bf47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 16l6 43 6-1.5-4.5-39z",
    fill: "#5e8e3e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 29,
    y: 50,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "S")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopifyLogo);
export default __webpack_public_path__ + "static/media/shopify-logo.5e2f1ec2eb3e4c60a6116f16fddb2ede.svg";
export { ForwardRef as ReactComponent };